import React from "react";
import {
  Form,
  ModalBody,
  Label,
  FormFeedback,
  Input,
  Spinner,
  Row,
  Col,
} from "reactstrap";
import SelectContractor from "../../Contracts/SelectContractor";
import Flatpickr from "react-flatpickr";
import SelectAgency from "pages/Users/SelectAgency";
import SelectConductedBy from "../RiskAssessments/SelectConductedByUser";
import SelectPVRFile from "./SelectPVRFile";

const PVRForm: React.FC<{
  toggle: () => void;
  loading: boolean;
  isUpdate?: boolean;
  validation: any;
  setLoading: (loading: boolean) => void;
}> = ({ validation, toggle, isUpdate, loading, setLoading }) => {
  return (
    <Form
      className="tablelist-form"
      onSubmit={(e) => {
        e.preventDefault();
        validation.handleSubmit();
        return false;
      }}
    >
      <ModalBody>
        <input type="hidden" id="id-field" />

        <div className="mb-3">
          <Label htmlFor="id-field" className="form-label">
            Report Title
          </Label>
          <Input
            name="title"
            id="title"
            className="form-control"
            placeholder="Enter report title"
            type="text"
            validate={{
              required: { value: true },
            }}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.title || ""}
            invalid={
              validation.touched.title && validation.errors.title ? true : false
            }
          />
          {validation.touched.title && validation.errors.title ? (
            <FormFeedback type="invalid">
              {validation.errors.title}
            </FormFeedback>
          ) : null}
        </div>

        <Row>
          <Col md={6} className="">
            <SelectAgency validation={validation} />
          </Col>
          <Col md={6} className="">
            <SelectContractor validation={validation} />
          </Col>
        </Row>

        <Row>
          <Col md={6} className="mb-3">
            <Label htmlFor="startDate-field" className="form-label">
              Verification / Report Date
            </Label>
            {/* @ts-ignore */}
            <Flatpickr
              name="verificationDate"
              id="verificationDate-field"
              className="form-control"
              placeholder="Select report date"
              options={{
                enableTime: false,
                altInput: false,
                altFormat: "d M, Y",
                dateFormat: "d M, Y",
              }}
              onChange={(e) => {
                validation.setFieldValue("verificationDate", e[0]);
              }}
              value={validation.values.verificationDate || ""}
            />
            {validation.touched.verificationDate &&
            validation.errors.verificationDate ? (
              <FormFeedback type="invalid">
                {validation.errors.verificationDate}
              </FormFeedback>
            ) : null}
          </Col>
          <Col md={6} className="">
            <SelectConductedBy validation={validation} />
          </Col>
        </Row>

        <Row>
          <Col md={12} className="mb-3">
            <Label htmlFor="id-field" className="form-label">
              Summary of findings
            </Label>
            <Input
              name="summary"
              id="summary"
              className="form-control"
              placeholder="Enter summary of findings"
              type="textarea"
              validate={{
                required: { value: true },
              }}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.summary || ""}
              invalid={
                validation.touched.summary && validation.errors.summary
                  ? true
                  : false
              }
            />
            {validation.touched.summary && validation.errors.summary ? (
              <FormFeedback type="invalid">
                {validation.errors.summary}
              </FormFeedback>
            ) : null}
          </Col>
        </Row>

        <Row>
          <SelectPVRFile validation={validation} />
        </Row>
      </ModalBody>

      <div className="modal-footer">
        <div className="hstack gap-2 justify-content-end">
          <button
            type="button"
            className="btn btn-light"
            onClick={() => {
              toggle();
            }}
          >
            Close
          </button>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading && (
              <Spinner
                color="light"
                size="sm"
                style={{ marginRight: "8px", marginBottom: "-1px" }}
              ></Spinner>
            )}
            {isUpdate ? "Update PVR" : " Add PVR"}
          </button>
        </div>
      </div>
    </Form>
  );
};

export default PVRForm;
